<div class="d-flex justify-content-between generic-row-item py-1" [ngClass]="{'without-sub' : withoutSub}" matRipple>
    <div class="d-flex flex-column" style="width: 100%; padding-left: 8px;" (click)="onClick()">
        <div>{{data.title}} {{data.data?.personName}}</div>
        <div *ngIf="!withoutSub">{{data.subtitle}}</div>
    </div>
    <div class="d-flex">
        <div *ngIf="displayEditPolygon">
            <button mat-icon-button (click)="polygonEditor()" 
            matTooltip="{{'tooltip_edit_polygon' | translate}}">
                <mat-icon>map</mat-icon>
            </button>
        </div>
        <!-- <div *ngIf="displayDelete">
            <button mat-icon-button (click)="delete()">
                <mat-icon>delete</mat-icon>
            </button>
        </div> -->
        <div style="align-self: center;" (click)="onClick()">
            <button mat-icon-button>
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </div>
</div>
